import React from 'react'
import PropTypes from 'prop-types'
import ResourceBar from '../ui/other/TopBarDefault'

const DefaultFrame = (props) => {
    const { children } = props
    return (
        <div className="game">
            <header className="game__header">
                <ResourceBar />
            </header>
            <div className="game__body">
                {React.Children.map(children, child => child)}
            </div>
            <div className="game__footer"><em>made by AllBitsEqual</em></div>
        </div>
    )
}

DefaultFrame.propTypes = {
    children: PropTypes.node.isRequired,
}

export default DefaultFrame
